import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
//-----------------------------------------------------------------------------
import {
  showDeleteConfirmationModal,
  setContentName,
  setDeleteCallback,
  setContentType,
} from 'containers/CarouselsDisplay/redux/actions/deleteConfirmationModal.actions';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import BookmarkProgressBar from '../../../../../../components/BookmarkProgressBar';
import { FadeInImage } from '../../../../../../components/FadeInImage';
import { useVerifyIsMobile } from '../../../../../../hooks/useVerifyIsMobile';
import { getRegion } from '../../../../../../utils/Region';
import { seenDeleteItem } from '../../../../redux/actions/cms.actions';
import './style.scss';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import { useNavigate } from 'react-router-dom';

export const SeenCard = ({
  contentInfo,
  node,
  index,
  contentType,
  carouselTitle,
  contentPosition,
}) => {
  const { isMobile } = useVerifyIsMobile(768);
  const { renderLabel } = useRenderChapas();
  const { nodesSelected } = useMenuRedirect();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleCardClick = e => {
    e.stopPropagation();

    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    //Redireccionamiento
    navigate(
      `/${getRegion()}/vcard/homeuser/${contentInfo.title_uri}/${
        contentInfo.id
      }`,
    );
  };

  const handleSeenDelClick = async e => {
    e.stopPropagation();
    // SETEA NOMBRE DE CONTENIDO, TIPO DE CARRUSEL Y MUESTRA MODAL DE CONFIRMACION
    dispatch(setContentName(contentInfo?.title));
    dispatch(setContentType(contentType));
    dispatch(showDeleteConfirmationModal);
    // SETEA CALLBACK PARA BORRADO
    dispatch(
      setDeleteCallback(() => {
        dispatch(seenDeleteItem({ contentId: contentInfo.id, index, node }));
      }),
    );
  };

  return (
    <div className="seen-card">
      {renderLabel(contentInfo)}

      <div className="seen-card__poster" onClick={handleCardClick}>
        <FadeInImage
          imageAlt={'Claro video poster'}
          imageSrc={contentInfo.image_large}
          width={isMobile ? 213 : 256}
          height={isMobile ? 120 : 144}
          classNames={['seen-card__image']}
        />
        {contentInfo.bookmark && contentInfo.bookmark.last.progress > 0 && (
          <BookmarkProgressBar
            isLive={contentInfo.content_type === 'L'}
            bookmarkProgress={contentInfo.bookmark.last.progress}
          />
        )}
      </div>
      <div className="seen-card__footer">
        <span className="seen-card__footer__title" onClick={handleCardClick}>
          {contentInfo.title}
        </span>
        <FaRegTrashAlt
          className="seen-card__footer__icon"
          onClick={handleSeenDelClick}
        />
      </div>
    </div>
  );
};
